import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { updateNotificationSettings } from 'services/endpoints/settings/notifications/notificationSettings'

export const useUpdateSettingsNotification = () => {
    const queryClient = useQueryClient()
    const { t } = useTranslation()

    return useMutation(
        async (newNotificationSettings: {
            note: string
            val: boolean
            type: string
        }) =>
            await updateNotificationSettings({
                type: newNotificationSettings.type,
                [newNotificationSettings.note]: newNotificationSettings.val
            }),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries('notificationSettings')
            },
            onError: err => {
                console.error(err)
                addToast('error', t('error:errorSomethingWentWrong'))
            }
        }
    )
}
